import { bind, Component, h, signal, tag } from "omi";

import { NWButton, NWIcon } from "@/components";
import { tailwind } from "@/tailwind";

import { ProductPriceName } from "./models";

type Props = {
  cta: string;
};

@tag("pricing-section-certifications-cta")
export class PricingSectionCertificationsCta extends Component<Props> {
  static css = [tailwind];

  private showContactInfo = signal(false);

  private onCertificationCtaClicked() {
    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackPaywallButtonClicked(ProductPriceName.PRO_PLUS_CERTS);
    });
  }

  @bind
  private onClick() {
    this.onCertificationCtaClicked();
    this.showContactInfo.value = true;
  }

  render({ cta }: Props) {
    return (
      <div class="w-full">
        {!this.showContactInfo.value && (
          <NWButton size="fit" type={"secondary"} loadingText={cta} onClick={this.onClick}>
            <span className="flex items-center gap-3 h-8">
              {cta} <NWIcon name="arrow-right" width={20} height={20} />
            </span>
          </NWButton>
        )}
        {this.showContactInfo.value && (
          <div className="px-3 py-4 w-full bg-secondary rounded-lg text-center text-sm text-quaternary animate-fadeInFast">
            Contact{" "}
            <a href="mailto:maya@nextwork.org" class="text-leather underline">
              maya@nextwork.org
            </a>{" "}
            to buy this plan.
          </div>
        )}
      </div>
    );
  }
}
